<template>
  <div>
    <v-toolbar v-if="isLoggedIn && this.screenSize === 'mobile'" dark :color="this.$gf.headerColor()">
      <v-app-bar-nav-icon @click="openNav = !openNav"></v-app-bar-nav-icon>
    </v-toolbar>
    <v-toolbar v-else-if="isLoggedIn" dark :color="this.$gf.headerColor()">
      <v-toolbar-items>
        <!--<v-btn text to="/super-admin/">Dashboard</v-btn>-->
        <v-btn text to="/invoicing-admin/companies">Companies</v-btn>
      </v-toolbar-items>
       <div class="flex-grow-1"></div>
      <span class="mr-4">Logged in as: {{ level }}</span>
      <template v-if="$vuetify.breakpoint.smAndUp">
        <v-btn icon @click="logout">
          <v-icon>fa-sign-out-alt</v-icon>
        </v-btn>
      </template>
    </v-toolbar>

    <transition name="nav-slide-down">
      <div v-if="this.openNav === true && this.screenSize === 'mobile'">
        <div class="nav-menu-container">
          
            <v-card style="padding: 10px 15px" flat to="/invoicing-admin/companies">Companies
          </v-card>
         

          <span style="padding: 10px 15px">Logged in as: {{ level }}</span>
          <v-btn icon @click="logout" style="background: #000000">
            <v-icon>fa-sign-out-alt</v-icon>
          </v-btn>
          <br />

        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { screensize } from '@/utils/screensize.js';
// Call the screensize function to get the screen size function
const getCurrentScreenSize = screensize();
const currentScreenSize = getCurrentScreenSize();

export default {
  name: 'InvoicingAdminNavigation',
  data() {
    return {
      screenSize: currentScreenSize,
      user: this.$store.getters.user.first_name,
      openNav: false,
    };
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
    level: function () {
      const user = this.$store.getters.user;
      return user.first_name + ' ' + user.last_name;
    },
    userName: function () {
      return this.$store.getters.isLoggedIn;
    },
    showAdmin: function () {
      return this.$store.getters.admin;
    },
    isInvoicingadmin: function () {
      if (this.$store.getters.level == 8)
        return true;
      else
        return false;
    },
  },
  created() {
    // Add event listener for screen size changes
    window.addEventListener('resize', this.handleResize);
  },
  mounted() {
    this.handleResize();
  },
  methods: {
    logout: function () {
      this.$store.dispatch('logout').then(() => {
        localStorage.removeItem('todos');
        this.$router.push('/login');
      });
    },
    handleResize() {
      this.screenSize = getCurrentScreenSize();
    },
  },
  beforeDestroy() {
    // Remove event listener when component is destroyed
    window.removeEventListener('resize', this.handleResize);

    this.screenSize = null;
  },
};
</script>
